module.exports = __webpack_public_path__ + "static/media/press-tc-article@3x.eab13ab4.jpg";